<template>
  <div class="card">
    <div class="p-3 text-center">
      <time
        :datetime="date.toISOString()"
        class="font-weight-bold text-condensed text-uppercase  mb-3 d-block font-lg"
      >
        {{ formattedDate() }}
      </time>
      <time
        :datetime="date.toISOString()"
        class="h1 text-secondary d-inline-block"
      >
        <span
          :class="[$style.badge]"
        >
          {{ pad(days) }}
          <small>{{ $tc('date.day', days) }}</small>
        </span>
        <span :class="$style.separator">:</span>
        <span :class="[$style.badge]">
          {{ pad(hours) }}
          <small>{{ $tc('date.hours', hours) }}</small>
        </span>
        <span :class="$style.separator">:</span>
        <span :class="[$style.badge]">
          {{ pad(minutes) }}
          <small>{{ $tc('date.minutes', minutes) }}</small>
        </span>
        <span :class="$style.separator">:</span>
        <span :class="[$style.badge]">
          {{ pad(seconds) }}
          <small>{{ $tc('date.seconds', seconds) }}</small>
        </span>
      </time>

      <slot/>
    </div>
  </div>
</template>

<script>
import countDown from '@/mixins/countDown'
import addSeconds from 'date-fns/add_seconds'
import { date } from '@/filters'

export default {
  name: 'CountDownTeaser',
  date: process.env.VUE_APP_EVENT_DATE,
  mixins: [countDown],
  computed: {
    remainingDate() {
      return addSeconds(new Date(0, 0, 0, 0, 0, 0), this.remaining)
    },
    days() {
      return Math.floor(this.remaining / 60 / 60 / 24)
    },
    hours() {
      return this.remainingDate.getHours()
    },
    minutes() {
      return this.remainingDate.getMinutes()
    },
    seconds() {
      return this.remainingDate.getSeconds()
    }
  },
  methods: {
    pad(text) {
      return `00${text}`.slice(-2)
    },
    format: date,
    formatHour(hour) {
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        hour: 'numeric',
        minute: 'numeric'
      }).format(hour)
    },
    formattedDate() {
      const timeDate = this.format(this.date, this.$i18n.locale, {
        month: 'long',
        day: 'numeric'
      })
      const hour = this.formatHour(this.date)
      return `${timeDate} | ${hour}`
    }
  }
}
</script>

<style lang="scss" module scoped>
.badge {
  background-color: $primary;
  padding: 8px;
  border-radius: 8px;
  display: inline-flex;
  flex-direction: column;
  color: white;
  font-size: 29px;

  > small {
    font-size: 9px;
    font-weight: $font-weight-base;
    color: white;
    text-transform: uppercase;
  }
}

.separator {
  display: inline-block;
  padding: 0 .375rem;
  color: $body-color;
  position: relative;
}
</style>
